import { useState, useCallback } from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';

export const useNavBarLogic = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const toggleMenu = useCallback(() => setMenuOpen((prev) => !prev), []);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const handleLogoClick = useCallback(() => navigate('/'), [navigate]);

  return {
    menuOpen,
    toggleMenu,
    closeMenu,
    handleLogoClick,
  };
};
